import './PrivacyPolicy.css';

export default function PrivacyPolicy({ onBack }) {
  return (
    <div className="privacy-container">
      <div className="privacy-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="privacy-card">
        <div className="privacy-header">
          <a href="#" className="back-btn" onClick={(e) => { e.preventDefault(); onBack(); }}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Back
          </a>
          <h1>Privacy Policy</h1>
          <div style={{ width: '80px' }}></div>
        </div>

        <div className="privacy-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              Costly Cure Portal ("we," "us," or "our") operates the website and services. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
            </p>
            <p>
              Please read this Privacy Policy carefully. If you do not agree with our policies and practices, please do not use our Service.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>
              We collect information in several ways:
            </p>
            <ul>
              <li><strong>Information You Provide:</strong> Name, email address, password, username, and any other information you voluntarily provide when creating an account or contacting us</li>
              <li><strong>Automatic Information:</strong> When you use our Service, we automatically collect certain information about your device, including IP address, browser type, operating system, and pages visited</li>
              <li><strong>Cookies and Tracking:</strong> We use cookies and similar tracking technologies to enhance your experience and understand how you use our Service</li>
              <li><strong>Model Information:</strong> Data related to AI models you upload, create, or manage on our platform</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>
              We use the information we collect for the following purposes:
            </p>
            <ul>
              <li>To provide, maintain, and improve our Service</li>
              <li>To process transactions and send related information</li>
              <li>To send administrative information, updates, and security alerts</li>
              <li>To respond to your inquiries and provide customer support</li>
              <li>To monitor and analyze trends, usage, and activities for security and fraud prevention</li>
              <li>To personalize and improve your experience</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and are liable for all activities occurring under your account.
            </p>
          </section>

          <section>
            <h2>5. Third-Party Services</h2>
            <p>
              Our Service may contain links to third-party websites and services that are not operated by us. This Privacy Policy does not apply to third-party websites, and we are not responsible for their privacy practices. We encourage you to review the privacy policies of any third-party services before providing your information.
            </p>
          </section>

          <section>
            <h2>6. Your Rights and Choices</h2>
            <p>
              Depending on your location, you may have the following rights:
            </p>
            <ul>
              <li>The right to access the personal information we hold about you</li>
              <li>The right to correct inaccurate or incomplete information</li>
              <li>The right to request deletion of your information</li>
              <li>The right to opt-out of certain data processing activities</li>
              <li>The right to data portability</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at support@canmage.com
            </p>
          </section>

          <section>
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies, web beacons, and similar tracking technologies to:
            </p>
            <ul>
              <li>Remember your preferences and settings</li>
              <li>Understand how you use our Service</li>
              <li>Measure the effectiveness of marketing campaigns</li>
              <li>Prevent fraud and enhance security</li>
            </ul>
            <p>
              You can control cookie settings through your browser, but disabling cookies may limit your access to certain features of our Service.
            </p>
          </section>

          <section>
            <h2>8. Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to provide our Service and fulfill the purposes outlined in this Privacy Policy. When you delete your account, we will remove your personal information within a reasonable timeframe, except as required by law.
            </p>
          </section>

          <section>
            <h2>9. Children's Privacy</h2>
            <p>
              Our Service is not directed to individuals under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected information from a child under 13, we will take steps to delete such information and terminate the child's access to the Service.
            </p>
          </section>

          <section>
            <h2>10. International Data Transfers</h2>
            <p>
              Your information may be transferred to, stored in, and processed in countries other than your country of residence. These countries may have data protection laws that differ from your home country. By using our Service, you consent to the transfer of your information to countries outside your country of residence.
            </p>
          </section>

          <section>
            <h2>11. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page with an updated effective date. Your continued use of the Service after such modifications constitutes your acceptance of the updated Privacy Policy.
            </p>
          </section>

          <section>
            <h2>12. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our privacy practices, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> support@canmage.com
            </p>
          </section>
        </div>

        <a href="#" className="back-btn-bottom" onClick={(e) => { e.preventDefault(); onBack(); }}>
          ← Back to Homepage
        </a>
      </div>
    </div>
  );
}
